/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import Smooch from 'smooch';
import { ZENDESK_ADA_WIDGET_TAG } from 'App/featuresFlags';
import { useGetPlan, useGetTags, useGetUserInfo } from 'domains/Auth/hooks';
import { useStoreInfo } from 'domains/PartnersApps/hooks';
import {
  onClose as smoochOnClose,
  onDestroy as smoochOnDestroy,
  onReceivedMessage as smoochOnReceivedMessage,
  startSmooch,
  toggleButton,
} from './startSmooch';

interface SunshineConversationsProps {
  onCloseModal: () => void;
  onReceivedMessage: () => void;
  onReady: () => void;
  onDestroy: () => void;
}

function SunshineConversations({
  onCloseModal,
  onReceivedMessage,
  onDestroy,
  onReady,
}: SunshineConversationsProps): null {
  const { id: externalId, email, firstName, lastName } = useGetUserInfo();
  const {
    id: storeId,
    country: countryCode,
    url: storeUrl,
    currentSegment,
    currentTheme,
    language,
    partnerId,
    name: storeName,
  } = useStoreInfo();
  const tags = useGetTags();
  const userName = firstName + ' ' + lastName;
  const { pathname } = useLocation();

  const { isNext, isEvolucion, niceName } = useGetPlan();

  const isAdaEnabled = tags.includes(ZENDESK_ADA_WIDGET_TAG);

  const smoochValues = useMemo(() => {
    if (!countryCode && !storeId) return false;
    return {
      externalId,
      userName: userName && userName.trim() ? userName : `User-${externalId}`,
      email,
      countryCode,
      storeId,
      storeUrl,
      onReady,
      isAdaEnabled,
      segment: currentSegment,
      theme: currentTheme,
      isEnterprisePlan: isNext || isEvolucion,
      plan: niceName,
      language,
      partnerId,
      storeName,
    };
  }, [
    externalId,
    userName,
    email,
    countryCode,
    storeId,
    storeUrl,
    isAdaEnabled,
    isNext,
    isEvolucion,
    niceName,
    currentSegment,
    currentTheme,
    language,
    partnerId,
    storeName,
  ]);

  useEffect(() => {
    if (smoochValues) {
      startSmooch(smoochValues);
    }

    return () => {
      Smooch.destroy();
    };
  }, [smoochValues]);

  useEffect(() => {
    toggleButton(0);
  }, [pathname]);

  useEffect(() => {
    smoochOnClose(onCloseModal);
  }, []);

  useEffect(() => {
    smoochOnReceivedMessage(onReceivedMessage);
  }, []);

  useEffect(() => {
    smoochOnDestroy(onDestroy);
  }, []);

  return null;
}
export default SunshineConversations;
